'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { GRAPHQL_FILES_FETCH } from 'DesignData/actions/ActionTypes';

const getUpdatedStateData = scripts => {
  const rawData = scripts;
  const byId = {};
  const byPath = {};
  const orderById = new Array(scripts.length);
  scripts.forEach((s, idx) => {
    orderById[idx] = s.id;
    byId[s.id] = byPath[s.path] = s;
  });
  return {
    rawData,
    byId,
    byPath,
    orderById
  };
};

export default function graphqlFiles(state = SeamlessImmutable({
  rawData: [],
  byId: {},
  byPath: {},
  orderById: []
}), action) {
  switch (action.type) {
    case GRAPHQL_FILES_FETCH:
      {
        const {
          payload
        } = action;

        if (!payload) {
          return state;
        }

        return state.replace(getUpdatedStateData(payload), {
          deep: true
        });
      }

    default:
      return state;
  }
}